/**
 * Club detail sections — shared by desktop tabs and mobile tile hub (M3).
 */

export const CLUB_SECTION_ORDER = [
  'overview',
  'map',
  'members',
  'calendar',
  'rules',
  'stats',
  'board',
  'admin',
];

export const CLUB_SECTIONS = {
  overview: {
    key: 'overview',
    label: 'Overview',
    sub: 'CLUB INFO · OFFICERS',
    glyph: '＋',
  },
  map: {
    key: 'map',
    label: 'Map',
    sub: 'STANDS · TAG OUT',
    glyph: '▲',
  },
  members: {
    key: 'members',
    label: 'Members',
    sub: 'MEMBERS',
    glyph: '◎',
  },
  calendar: {
    key: 'calendar',
    label: 'Calendar',
    sub: 'BOOK A SIT',
    glyph: '■',
  },
  rules: {
    key: 'rules',
    label: 'Rules',
    sub: 'CLUB RULES',
    glyph: '☰',
  },
  stats: {
    key: 'stats',
    label: 'Stats',
    sub: 'SEASON · LOG',
    glyph: '◔',
  },
  board: {
    key: 'board',
    label: 'Board',
    sub: 'POSTS · THREADS',
    glyph: '✉',
  },
  admin: {
    key: 'admin',
    label: 'Admin',
    sub: 'SETTINGS',
    glyph: '⚙',
    gated: true,
  },
};

/**
 * Resolve hub vs drilled-in section for club detail.
 * Mobile: no explicit tab → hub (tab null). Desktop: default overview.
 */
export function resolveClubDetailSectionMode({
  isMobile = false,
  tabParam = null,
  pathActiveTab = null,
} = {}) {
  const explicit = tabParam || pathActiveTab || null;
  if (isMobile && !explicit) {
    return { mode: 'hub', tab: null };
  }
  return { mode: 'section', tab: explicit || 'overview' };
}

export function clubSectionLabel(key) {
  return CLUB_SECTIONS[key]?.label || String(key || '').toUpperCase();
}

/** Loden club-name band: hub + desktop only. Mobile sections keep the back bar. */
export function shouldShowClubNameTopbar({
  mapExpanded = false,
  isMobile = false,
  displayTab = null,
} = {}) {
  if (mapExpanded) return false;
  if (isMobile && displayTab) return false;
  return true;
}
